<!-- Start 404 Error -->
<div class="error-area ptb-100">
    <div class="error-content">
        <h1>4 <span>0</span> 4</h1>
        <h3>Oops! Page Not Found</h3>
        <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
        <a routerLink="/" class="default-btn">Return To Home Page</a>
    </div>
</div>
<!-- End 404 Error -->